<template>
  <v-content>
    <v-container>
      <v-card
        flat
        outlined
        color="transparent"
      >
        <v-card-title>Equipment</v-card-title>
        <v-divider />
        
        <v-row
          no-gutters
          class="mt-5"
        >
          <v-col md="6" sm="12">
            <v-card-text
              class="mt-5"
            >
              <ul class="title">
                <li>2 Mazak CNC Machining Centers (20y x 40 x 20z)</li>
                <li>4 Vertical Mills (38" x 14" x 18")</li>
                <li>2 Mazak CNC Lathes (10 inch)</li>
                <li>Acer Lathe (17 inch)</li>
                <li>Hardinge Precision Lathe</li>
                <li>Blanchard Grinder (36 inch)</li>
                <li>Clausing Surface Grinder (6” x 18”)</li>
                <li>Do-All Vertical Bandsaw (16 inch)</li>
                <li>Kalamazoo Horizontal Bandsaw (9”Round 14”Flat)</li>
                <li>Lucifer Heat Treat Furnace (9” H x 12” W x 21” L)</li>
              </ul>
            </v-card-text>
          </v-col>
          <v-col md="3" sm="12">
            <div class="justify-center">
              <v-img
                  :src="require('../assets/machine1.jpg')"
                  width="300px"
                  height="350px"
                  contain
              ></v-img>
            </div>
          </v-col>
          <v-col md="3" sm="12">
            <v-img
                  :src="require('../assets/machine2.jpg')"
                  width="300px"
                  height="350px"
                  contain
            ></v-img>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>


export default {
  name: 'equipmentCapabilities',
  components: {

  },
  props: [

  ],
   data () {
      return {
        capabilities: [
          "cap1",
          "cap2"
        ]
      }
   }
}
</script>

<style scoped>

</style>


<style src="../index.css"></style>